import React from 'react';
import { signInWithGoogle, signInAnon } from '@flowfocus/core';
import { Logo } from '../components/Logo';

export function AuthPage() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg-app)' }}>
      <div className="card" style={{ maxWidth: 380, width: '100%', margin: 24, padding: '48px 32px', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <Logo size={64} />
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 800, letterSpacing: '-0.5px', color: 'var(--text-pri)', marginBottom: 8 }}>FlowFocus</h1>
        <p style={{ fontSize: 14, color: 'var(--text-sec)', marginBottom: 32, lineHeight: 1.5 }}>
          Tu espacio de estudio y trabajo.<br />Pomodoro · tareas · calendario.
        </p>

        <button className="btn-primary" style={{ width: '100%', padding: '12px' }} onClick={signInWithGoogle}>
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path fill="currentColor" d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81Z" />
          </svg>
          Continuar con Google
        </button>

        <button className="btn-ghost" style={{ width: '100%', justifyContent: 'center', marginTop: 10, color: 'var(--text-mut)' }} onClick={() => signInAnon()}>
          Usar sin cuenta
        </button>

        <p style={{ marginTop: 20, fontSize: 12, color: 'var(--text-mut)' }}>Sin cuenta funciona offline en este dispositivo. Inicia sesión cuando quieras y se conserva todo.</p>
      </div>
    </div>
  );
}
